import React from 'react';
import { OrbitComponent } from '../base-components/orbit-component/orbit-component';
import { RedTigerJackpotWidgetConfiguration } from '../../services/configurations/config-data-sections/red-tiger-jackpot-widget.configuration';
import { observer } from 'mobx-react';
import { RedTigerWidgetBox } from './boxes/widget/red-tiger-widget.box';
import { RedTigerWidgetHitAreaBox } from './boxes/hitArea/red-tiger-widget-hit-area.box';
import { RedTigerWidgetFrameContainerBox } from './boxes/frameContainer/red-tiger-widget-frame-container.box';
import { CyClass } from '../../../common/cy-classes';

interface RedTigerWidgedComponentProps {
    widgetConfig?: RedTigerJackpotWidgetConfiguration;
}

export const RedTigerWidgetComponent = observer(
    class RedTigerWidgetComponent extends OrbitComponent<RedTigerWidgedComponentProps> {
        
        private _onWidgetClick = () => {
            this.services.redTiger.redirectToWidgetActionLink(this.props.widgetConfig.actionLink);
        }
        
        private _logMissingProps() {
            if (!this.props.widgetConfig.actionLink) {
                // actionLink is optional. For example on 777 we don't have it
                this.services.logger.info('Missing actionLink parameter for RedTigerWidgetComponent');
            }

            if (!this.props.widgetConfig.parameters?.skin) {
                this.services.logger.warning('Missing skin parameter for RedTigerWidgetComponent');
            }

            if (!this.props.widgetConfig.parameters?.jackpotId) {
                this.services.logger.warning('Missing jackpotId parameter for RedTigerWidgetComponent');
            }
        }

        render() {
            if(!this.props.widgetConfig?.display) {
                return null;
            }
            this._logMissingProps();

            return (
                <RedTigerWidgetBox className='cy-red-tiger-widget'>
                    <RedTigerWidgetHitAreaBox className={CyClass('cy-cgp-red-tiger-widget-click-detector')} onClick={this._onWidgetClick}>
                        <RedTigerWidgetFrameContainerBox frameBorder='0' scrolling='no' src={this.services.redTiger.getWidgetUrl(this.props.widgetConfig.parameters)} className={CyClass('cy-jackpot-widget')}></RedTigerWidgetFrameContainerBox>
                    </RedTigerWidgetHitAreaBox>
                </RedTigerWidgetBox>
            );
        }
    }
);
